import { gql } from '@apollo/client';

export const GET_ALL_SPECIALIST = gql`
query SortedSpecialist($isActive: Boolean = true, $hasEvents: Boolean = true) {
    sortedSpecialist(isActive: $isActive, hasEvents: $hasEvents) {
        id
        name
        photo
        photoResized
        video
        slug
        experience
        direction
        specialisation
        length
        pairDetails
        sortOrder
        onlineCount
        offlineCount
        officeCount
        closestEvent
        addresses{
          edges{
            node{
              id
              address
              metro
              isActive
              town
              district
              nickAddress
            }
          }
        }
        servicesSet{
          edges{
            node{
              id
              meetingType
              price            
              duration
            }
          }
        }
        problems {
          edges{
            node{
              id
              title
            }
          }
        }     
    }
}`;

export const GET_ONE_SPECIALIST = gql`
query getOneSpecialist($slug: String!) { 
    allSpecialist(slug: $slug){
        edges{
          node{
            id
            name
            photo
            photoResized
            slug
            direction
            video
            length
            specialisation
            experience
            memberships {
              edges {
                node {
                  short
                  full
                }
              }
            }
            educations{
              edges{
                node{
                  id
                  institute
                  speciality
                  qualification
                  graduationYear
                  yearsOfStudy
                }
              }
            }
            descriptionFull
            quote
            isActive
            servicesSet{
              edges{
                node{
                  id
                  meetingType
                  price            
                }
              }
            }
            addresses{
              edges{
                node{
                  id
                  address
                  metro
                  town
                  district
                  isActive
                  nickAddress
                }
              }
            }
            problems {
              edges{
                node{
                  id
                  title
                }
              }
            }     
          }
        }
    }
}`;

export const GET_SPECIALIST_DETAILS = gql`
query SortedSpecialist($isActive: Boolean = true, $slug: String, $hasEvents: Boolean = true) {
    sortedSpecialist(isActive: $isActive, slug: $slug, hasEvents: $hasEvents) {
        id
        name
        pairDetails
        onlineCount
        offlineCount
        officeCount
     }
}
`;
